import React from 'react';
import { SelectComponents } from '../../types';
import { InnerMenuItem } from './InnerMenuItem';

export const Option: NonNullable<SelectComponents['Option']> = (props) => {
  const { key, ...optionProps } = props.optionProps ?? {};
  return (
    <InnerMenuItem
      key={key}
      optionProps={optionProps}
      option={props.option ?? {}}
      dataTest={props.dataTest}
      searchTerm={props.searchTerm}
      noWrapSubLabel={props?.noWrapSubLabel}
      iconSize={props?.iconSize}
    />
  );
};
